import $http from '@/config/request'

//我的收藏
export const getCollectListApi = params => {
  return $http.get(`/resource/rsc-info/collect/rscs?userNo=${params.userNo}&rscFileType=${params.rscFileType}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`)
}
